import { ICourse, IProgram, isCourse, SearchType } from './ISearchService';

function prefixFor (favoriteType: SearchType) {
	return SearchType[favoriteType];
}

function keyFor (favorite: IProgram | ICourse): string {
	const favoriteType = isCourse(favorite) ? SearchType.Course : SearchType.Program;
	const prefix = prefixFor(favoriteType);
	return `${prefix}:${favorite.id}`;
}

export class SessionStorage {
	// the user has dismised the warning that their favorites will be deleted when the tab closes
	static get dismissedFavWarning (): boolean {
		const value = sessionStorage.getItem('dismissedFavWarning');
		return value === 'true';
	}

	static set dismissedFavWarning (dismissed: boolean) {
		sessionStorage.setItem('dismissedFavWarning', dismissed.toString());
	}

	static get dismissedDisclaimer (): boolean {
		const value = sessionStorage.getItem('dismissedDisclaimer');
		return value === 'true';
	}

	static set dismissedDisclaimer (dismissed: boolean) {
		sessionStorage.setItem('dismissedDisclaimer', dismissed.toString());
	}

	static addFavorite (favorite: IProgram | ICourse): void {
		sessionStorage.setItem(keyFor(favorite), JSON.stringify(favorite));
	}

	static removeFavorite (favorite: IProgram | ICourse): void {
		sessionStorage.removeItem(keyFor(favorite));
	}

	static getProgramFavorites (): IProgram[] {
		return [...SessionStorage.getStoredFavorites<IProgram>(SearchType.Program)];
	}

	static getCourseFavorites (): ICourse[] {
		return [...SessionStorage.getStoredFavorites<ICourse>(SearchType.Course)];
	}

	static* getStoredFavorites<T> (favoriteType: SearchType): IterableIterator<T> {
		const prefix = prefixFor(favoriteType);

		for (let n = 0; n <= sessionStorage.length; n++) {
			const key = sessionStorage.key(n);
			if (key && key.startsWith(prefix)) {
				const json = sessionStorage.getItem(key);
				if (json) {
					yield JSON.parse(json) as T;
				}
			}
		}
	}
}
